import Guard from '@/services/middleware'

const ExternalLayout = () => import('@/layouts/ExternalLayout.vue')
const PageChangeLog = () => import('@/views/web/changelog/PageChangeLog.vue')

export default [
    {
        path: '/atualizacoes',
        component: ExternalLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated],
        children: [{ path: '', name: 'page.changelog', component: PageChangeLog, meta: { title: 'Central de Atualizações' } }],
    },
]